import axios from 'axios'
import { useAppState } from '../redux';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { QueryKeys } from '../../constants/query-keys';
import { IDataCutConnection } from '../../components/GlobalJobMatching/PricingVersionStepper/Steps/DataCutsTypes';

export const useRulesBasedPricingDataCuts = ({ dataCutPriority, enabled }: { dataCutPriority: string, enabled: boolean }) => {
  const { session: { masterAccountId, csrf_token, csrf_timestamp } } = useAppState()

  const fetchDataCuts = async (): Promise<IDataCutConnection[]> => {
    const response = await axios.get(`/cms/api/accounts/${masterAccountId}/rules-based-pricing/dataCuts/${dataCutPriority}/?csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`);

    if (response.status === 200 && response.data) {
      return response.data.data
    } else {
      throw new Error('Error getting data cuts')
    }
  }

  const query = useQuery([QueryKeys.RULES_BASED_PRICING_DATA_CUTS, { dataCutPriority }], fetchDataCuts, {
    enabled
  })

  return query
}

type UpdateDataCutPayload = {
  dataCutPriority: string | number
  priorityValue: string | number
  dataCutConnectionId: number
}

export const useUpdateRulesBasedPricingDataCut = () => {
  const { session: { masterAccountId, csrf_token, csrf_timestamp } } = useAppState()
  const queryClient = useQueryClient()

  const updateDataCut = async ({ dataCutPriority, priorityValue, dataCutConnectionId }: UpdateDataCutPayload): Promise<any> => {
    const numericPriority = typeof priorityValue === 'number' ? priorityValue : Number(priorityValue);
    if (isNaN(numericPriority) || numericPriority < 1) return;

    const response = await axios.put(`/cms/api/accounts/${masterAccountId}/rules-based-pricing/dataCut/${dataCutPriority}/?csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`, { priority: priorityValue, dataCutConnectionId });
    return response.data
  }


  const mutation = useMutation(updateDataCut, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeys.RULES_BASED_PRICING_DATA_CUTS])
    }
  })

  return mutation
}
